export const navigator = {
    step: "modelSelect",
    steps: [
        {
            step: "modelSelect",
            title: "vehicle select",
            label: "Choose your electric vehicle",
            next: "dealerSelect",
            showNavigation: true,
            pills: {
                item: 1,
                total: 4,
            },
        },
        {
            step: "dealerSelect",
            title: "Select Dealer",
            label: "Choose a dealer",
            next: "dateSelect",
            previous: "modelSelect",
            showNavigation: true,
            pills: {
                item: 2,
                total: 4,
            },
        },
        {
            step: "dateSelect",
            title: "Select Time?",
            label: "Select a date",
            next: "details",
            previous: "dealerSelect",
            showNavigation: true,
            pills: {
                item: 3,
                total: 4,
            },
        },
        {
            step: "details",
            title: "Details",
            label: "Your Details",
            next: "confirmation",
            previous: "dateSelect",
            showNavigation: true,
            pills: {
                item: 4,
                total: 4,
            },
        },
        {
            step: "confirmation",
            title: "Confirmation of your appointment request",
            label: "Confirmation of your appointment request",
            next: null,
            previous: "dateSelect",
            showNavigation: true,
            pills: {
                item: 4,
                total: 4,
            },
        },
    ],
};



// WEBPACK FOOTER //
// ./resources/assets/js/cms-content-slices/components/electric-test-drive/navigator.js